import { React,useEffect,useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './novoBoleto.css';
import imgAdicionar from '../../img/add.png';
import imgSubtrair from '../../img/sub.png';
import { InputMask } from '@react-input/mask';
import Alert from "@mui/material/Alert";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function NovoBoleto() {

    //#region constantes
    const navigate = useNavigate();

    const location = useLocation();

    const [dadosGerais, setDadosGerais] = useState({});

    const [mesesEmAberto, setMesesEmAberto] = useState([]);
    const [mesesSelecionados, setMesesSelecionados] = useState([]);
    const [dadosPorMes, setDadosPorMes] = useState([]);

    const [qtdeMeses, setQtdeMeses] = useState(1);
    const [valorBoleto, setValorBoleto] = useState(0);
    
    /* Constantes para controlar o foco do mouse nos botões */
    const [isHoverAvancar, setIsHoverAvancar] = useState(false);
    const [isHoverVoltar, setIsHoverVoltar] = useState(false);

    const [msgAviso, setMsgAviso] = useState("");
    //#endregion


    //#region handle mouse
    const handleMouseEnterAvancar = () => {
        setIsHoverAvancar(true);
    };

    const handleMouseLeaveAvancar = () => {
        setIsHoverAvancar(false);
    };

    const handleMouseEnterVoltar = () => {
        setIsHoverVoltar(true);
    };

    const handleMouseLeaveVoltar = () => {
        setIsHoverVoltar(false);
    };
    //#endregion


    //#region functions
    function AddQtdeMeses(){
        if (qtdeMeses < mesesEmAberto.length) {
            setQtdeMeses(qtdeMeses + 1);
        }
    }

    function SubQtdeMeses(){
        if (qtdeMeses > 1) {
            setQtdeMeses(qtdeMeses - 1);
        }
    }

    function changeQtdeFuncionarios(index, qtde){

        setMsgAviso("");
        dadosPorMes[index].qtde = Number(qtde);
        dadosPorMes[index].total = Number(qtde*dadosPorMes[index].valor);
        setDadosPorMes(dadosPorMes);

        const total = dadosPorMes.reduce((soma, valorAtual) => {
            return soma + valorAtual.total;
        }, 0);

        setValorBoleto(total);

    }

    function isQtdeInformadaParaTodosMesesSelecionados(){

        let qtZeros = 0;

        mesesSelecionados.map((mes, index) => {

            if(dadosPorMes[index].qtde <= 0){
                qtZeros = qtZeros + 1;
            }

        });

        return qtZeros === 0;

    }

    function Avancar(){
        
        if (!isQtdeInformadaParaTodosMesesSelecionados()){
            setMsgAviso("Preencha todos o campos de quantidade de funcionários!");
            return;
        }

        // Monta objeto com dados para revisão
        let meses = [];

        mesesSelecionados.map((item , index) => {

            const mes = {
                REFERENCIA: Number(item.REFERENCIA),
                REFERENCIA_STR: item.REFERENCIA_STR,
                VALOR_POR_EMPREGADO: Number(item.VALOR_POR_EMPREGADO),
                PARCELA: Number(item.PARCELA),
                QTDE_FUNCIONARIOS: Number(dadosPorMes[index].qtde),
                VALOR_TOTAL: Number(dadosPorMes[index].total),
                DATA_VENCIMENTO: item.DATA_VENCIMENTO,
                COBRAR_MULTA_JUROS: item.COBRAR_MULTA_JUROS,
                STATUS: item.STATUS
            }

            meses.push(mes);

        });

        const dados = {
            dadosgerais: dadosGerais,
            mesesselecionados: meses
        }

        navigate("/revisaoboleto", {state : dados});


    }

    function Voltar(){

        const dados = {
            ID_EMPRESA: dadosGerais.EMPRESA.ID_EMPRESA
        };

        navigate("/menuextrato", { state: dados });

    }
    //#endregion    


    //#region useEffect
    useEffect(() => {

        setDadosGerais(location.state);

        const mesesAberto = location.state.EXTRATO_PAGAMENTOS.filter(item => item.STATUS === 'A');

        setMesesEmAberto(mesesAberto);

        let dadosMes = [];

        mesesAberto.map((item) => {

            const mes = {
                qtde: 0,
                valor: item.VALOR_POR_EMPREGADO,
                total: 0
            }

            dadosMes.push(mes);

        });

        setDadosPorMes(dadosMes);

    }, []);

    useEffect(() => {

        setMesesSelecionados(location.state.EXTRATO_PAGAMENTOS.filter(item => item.STATUS === 'A').filter((item, index) => index < qtdeMeses));

    }, [qtdeMeses]);
    //#endregion


    //#region html
    return (
        <div>
            {
                (Object.keys(dadosGerais).length > 0) ? (

                    <div className="form-control"
                        style={{padding:"10px 10px 0 10px",
                                textAlign:'center',
                                backgroundColor:'#fff',
                                height:'89.9vh',
                                overflow:'auto'}}>
    
                        <div className="form-control">

                            <div className="cnpjcpf-content-container" 
                                    style={{backgroundColor:'#fff',
                                            marginBottom:'0.5rem'}}>

                                {/* Titulo */}
                                <div style={{fontSize:'24px',
                                                color:'#423c89',
                                                backgroundColor:'#fff',
                                                marginBottom:'0.5rem'}}>
                                    <h3>Emissão de boleto</h3>
                                </div>

                                {/* Corpo */}
                                <div style={{fontSize:'16px',
                                            backgroundColor:'#fff',
                                            marginBottom:'0.5rem'}}>
                                    
                                    {/* Dados da empresa */}
                                    <div style={{backgroundColor:'gray', 
                                                    width:'100%',
                                                    margin:'auto',
                                                    color:'white',
                                                    borderRadius:'0.5rem'}}>
                                        Dados da empresa
                                    </div>

                                    {/* CNPJ */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>CNPJ:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.CNPJ}</span>
                                    </div>

                                    {/* NOME_FANTASIA */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>Nome Fantasia:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.NOME_FANTASIA}</span>
                                    </div>

                                    {/* RAZAO_SOCIAL */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>Razão social:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.RAZAO_SOCIAL}</span>
                                    </div>


                                    {/* Quantos meses deseja pagar ? */}
                                    <div style={{backgroundColor:'gray', 
                                                    width:'100%',
                                                    margin:'auto',
                                                    color:'white',
                                                    borderRadius:'0.5rem',
                                                    marginTop:'1rem'}}>
                                        Dados para gerar boleto
                                    </div>

                                    <div style={{width:'300px',
                                                backgroundColor:'silver',
                                                margin:'auto',
                                                marginTop:'1rem',
                                                //minHeight:'200px',
                                                borderRadius:'0.5rem'}} >

                                        <div style={{fontWeight:'bold'}}>Pagamento</div>
                                        <div>Quantos meses deseja pagar ?</div>
                                        <div style={{fontWeight:'bold',color: '#2957A4', fontSize:'2rem'}}>{qtdeMeses}</div>
                                        <div style={{display:'inline-block',width:'60px',height:'60px',marginRight:'0.3rem',cursor:'pointer'}}>
                                            <img src={imgSubtrair} onClick={() => SubQtdeMeses()}></img>
                                        </div>
                                        <div style={{display:'inline-block',width:'60px',height:'60px',marginLeft:'0.3rem',cursor:'pointer'}}>
                                            <img src={imgAdicionar} onClick={() => AddQtdeMeses()}></img>
                                        </div>
                                        <div style={{marginTop:'0.5rem'}}>Valor total do boleto</div>
                                        <div style={{fontWeight:'bold',color:'blue'}}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(valorBoleto)}</div>
                                       

                                        {/* DIV dos botões tdtoaki */}
                                        <div>

                                            {/* Voltar */}
                                            <div style={{backgroundColor: isHoverVoltar ? '#2957A4' : '#fff',
                                                        width:'100px', display:'inline-block',
                                                        height:'28px',
                                                        alignContent: 'center',
                                                        cursor:'pointer',
                                                        margin:'auto',
                                                        color: isHoverVoltar ? '#fff' : 'black',
                                                        marginRight:'5px',
                                                        borderRadius:'0.5rem',
                                                        borderWidth:'0.2rem',
                                                        borderStyle:'solid',
                                                        borderColor:'#2957A4',
                                                        marginTop:'1rem',
                                                        marginBottom:'1rem'}}
                                                onMouseEnter={handleMouseEnterVoltar}
                                                onMouseLeave={handleMouseLeaveVoltar}
                                                onClick={Voltar}>
                                                Voltar
                                            </div>

                                            {/* Novo boleto */}
                                            <div style={{backgroundColor: isHoverAvancar ? '#0033EA' : '#2957A4',
                                                        width:'100px', display:'inline-block',
                                                        height:'28px',
                                                        alignContent: 'center',
                                                        cursor:'pointer',
                                                        margin:'auto',
                                                        color:'white',
                                                        borderRadius:'0.5rem',
                                                        borderWidth:'0.2rem',
                                                        borderStyle:'solid',
                                                        borderColor:isHoverAvancar ? '#0033EA' : '#2957A4', 
                                                        marginLeft:'5px',
                                                        marginTop:'1rem',
                                                        marginBottom:'1rem'}}
                                                onMouseEnter={handleMouseEnterAvancar}
                                                onMouseLeave={handleMouseLeaveAvancar}
                                                onClick={Avancar}>
                                                Avançar
                                            </div>
                                        </div>

                                        {
                                            (msgAviso) ? (
                                                <Alert icon={<WarningAmberIcon />}
                                                        severity="warning"
                                                        style={{width:'98%',
                                                                margin:'auto',
                                                                marginBottom:'1rem' }}>
                                                    {msgAviso}
                                                </Alert>

                                            ) : null
                                        }


                                        {/* Títulos */}
                                        <div style={{padding:'0.2rem',
                                                     width:'98%',
                                                     backgroundColor:'#fff',
                                                     margin:'auto',
                                                     borderRadius:'0.5rem',
                                                     marginBottom:'0.3rem',
                                                     fontWeight:'bold'}}>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.3%'}}>Mês de referência</div>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.3%'}}>Valor por funcionário</div>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.4%'}}>Nº de funcionários</div>
                                        </div>


                                        {
                                            mesesSelecionados.map((item, index) => (

                                                /* Card das referências */
                                                <div key={item.REFERENCIA}
                                                     style={{marginTop:'0.5rem',
                                                            width:'98%',
                                                            backgroundColor:'white',
                                                            height:'30px',
                                                            margin:'auto',
                                                            borderRadius:'0.5rem',
                                                            textAlign:'center',
                                                            padding:'0rem',
                                                            marginBottom:'0.3rem'}}>

                                                    {/* Referência/Valor/Qtde funcionários */}
                                                    <div style={{padding:'0.2rem'}}>

                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.3%',fontWeight:'bold'}}>
                                                            {item.REFERENCIA_STR}
                                                        </div>
                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.3%',fontWeight:'bold'}}>
                                                            {new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(item.VALOR_POR_EMPREGADO)}
                                                        </div>
                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.4%',fontWeight:'bold'}}>

                                                            <InputMask mask="__" 
                                                                       replacement={{ _: /\d/ }} 
                                                                       showMask={false} 
                                                                       id="edtQtdeFuncionarios" 
                                                                       inputMode='numeric'

                                                                defaultValue={0}
                                                                onChange={(e) => changeQtdeFuncionarios(index,e.target.value)} /* tdtoaki */
                                                                style={{width:'60%',
                                                                        height:'22px',
                                                                        textAlign: 'center',
                                                                        border:'none',
                                                                        borderRadius:'0.3rem',
                                                                        backgroundColor: '#F5A402',//'#80B4F0', //'#F5A402',
                                                                        WebkitAppearance: 'none',
                                                                        margin: 0}} />

                                                        </div>

                                                    </div>
                                                </div>

                                            ))
                                        }

                                        <br />

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                ): (
                    <div>Carregando...</div>
                )
            }

        </div>
    )
    //#endregion
}

export default NovoBoleto;
